import { CurrentUser } from "../Helpers/CurrentUser";
import api from "./api";

export const getPingSessionSummaries = async () => {
	return api
        .get(process.env.REACT_APP_SERVER_URL + "/PingSession/GetSummaries", {headers: {"Authorization":CurrentUser.getToken()}})
		.then((response) => {
			return response.data;
		});
}

const buildArrayQueryParams = (key, values) =>
	(values ?? []).map((value) => `${key}=${encodeURIComponent(value)}`).join("&");

export const getPingSessionSummariesPaged = async (page, pageSize, origins = [], destinations = [], ratings = [], signal) => {
	const arrayParams = [
		buildArrayQueryParams("origins", origins),
		buildArrayQueryParams("destinations", destinations),
		buildArrayQueryParams("ratings", ratings),
	].filter(Boolean).join("&");

	const url = process.env.REACT_APP_SERVER_URL
        + `/PingSession/GetSummariesPaged?page=${page}&pageSize=${pageSize}`
        + (arrayParams ? `&${arrayParams}` : "");

	return api
        .get(url, {headers: {"Authorization":CurrentUser.getToken()}, signal})
		.then((response) => {
			return response.data;
		});
}

export const getPingSessionLocationOptions = async (signal) => {
	return api
        .get(process.env.REACT_APP_SERVER_URL + `/PingSession/GetLocationOptions`, {headers: {"Authorization":CurrentUser.getToken()}, signal})
		.then((response) => {
			return response.data;
		});
}

export const getPingSession = async (pingSessionId) => {
    return api
        .get(process.env.REACT_APP_SERVER_URL + `/PingSession/GetById?Id=${pingSessionId}`, {headers: {"Authorization":CurrentUser.getToken()}})
        .then((response) => {
            return response.data;
        });
}

export const deletePingSession = async (pingSessionId) => {
    return api
        .delete(process.env.REACT_APP_SERVER_URL + `/PingSession/delete?Id=${pingSessionId}`, {headers: {"Authorization":CurrentUser.getToken()}})
        .then((response) => {
            return response.data;
        });
}

export const setPingSessionRating = async (pingSessionId, rating) => {
    return api
        .post(process.env.REACT_APP_SERVER_URL + `/PingSession/SetRating?id=${pingSessionId}&rating=${rating}`, {}, {headers: {"Authorization":CurrentUser.getToken()}})
        .then((response) => {
            return response.data;
        });
}

export const getSharedPingSession = async (sharedSessionId) => {
    return api
        .get(process.env.REACT_APP_SERVER_URL + `/SharedSession?sharedSessionId=${sharedSessionId}`)
        .then((response) => {
            return response.data;
        });
}

export const sharePingSession = async (pingSessionId) => {
    return api
        .post(process.env.REACT_APP_SERVER_URL + `/SharedSession?pingSessionId=${pingSessionId}`,{}, {headers: {"Authorization":CurrentUser.getToken()}})
        .then((response) => {
            return response.data;
        });
}